import React from "react";

import cx from "classnames";

import getHeroImageSizeGroup, {
  getHeroImageSize,
} from "@globals/functions/getHeroImageSizeGroup";

import LoadingSkeleton from "@components/LoadingSkeleton";
import MediaAlbumCarousel from "@components/MediaAlbumCarousel";

import {Brand} from "../interfaces";
import styles from "./BrandInfo.scss";
import commingSoonImage from "./img/coming-soon.png";

type BrandInfoProps = {
  brand?: Brand;
  isLoading?: boolean;
};

export default function BrandInfo({
  brand,
  isLoading = false,
}: BrandInfoProps): JSX.Element {
  const hasLogo = Boolean(brand?.logo);
  const hasDescription = Boolean(brand?.description);
  const heroMediaAlbum = brand?.brand_media_album;
  const hasMultipleImages = heroMediaAlbum && heroMediaAlbum?.mediae.length > 1;

  return (
    <>
      <div className={styles.logoRow}>
        <LoadingSkeleton isLoading={isLoading} className={styles.logo}>
          {hasLogo && (
            <div className={styles.logo}>
              <img src={brand?.logo?.url} alt={brand?.name} />
            </div>
          )}
        </LoadingSkeleton>
        <LoadingSkeleton isLoading={isLoading} className={styles.heading}>
          {brand && <h1 className={styles.heading}>{brand.name}</h1>}
        </LoadingSkeleton>
      </div>

      <div
        className={cx(
          styles.hero,
          hasMultipleImages && styles.multipleHeroImages
        )}
      >
        <LoadingSkeleton
          isLoading={isLoading}
          className={styles.photoComingSoon}
        >
          {heroMediaAlbum ? (
            <MediaAlbumCarousel
              key={brand.id}
              mediaAlbum={heroMediaAlbum}
              imageSizeGroup={getHeroImageSizeGroup()}
              size={getHeroImageSize()}
              wrapperClassName={styles.media}
              showThumbnails={false}
            />
          ) : (
            <img
              src={commingSoonImage}
              className={styles.photoComingSoon}
              alt=""
            />
          )}
        </LoadingSkeleton>
        {hasDescription && (
          <div className={styles.description}>
            <p>{brand?.description}</p>
          </div>
        )}
      </div>
    </>
  );
}
